import { APIClient } from "./apiCore";
import { sp_GetWebUserId } from "types"
import * as url from "./urls";
import { Utils } from "../helpers/utils";
import { UserTypes } from "api";



const api = new APIClient();

const getFavourites = () => {
  return api.get(url.GET_FAVOURITES);
};

// const getChatRoomLists = () => {
//   return api.fnGet("chat-get-contact-list");
// }

const getChatRoomListsV2 = (
  filterKeywords: string, pageToFetch: number, groupType: UserTypes
  , filterUnread?: boolean | null, filterPersonUnRead?: boolean | null, filterNoActivity?: boolean | null, filterSaleIds?: number[], filterCsIds?: number[], filterProvinceIds?: number[]
  , companyType?: string
) => {
  // console.log('getChatRoomListsV2 (API):', { filterKeywords, pageToFetch, groupType, filterUnread, filterPersonUnRead, filterNoActivity, filterSaleIds, filterCsIds, filterProvinceIds });
  return api.fnPostForm("/chat-get-contact-list2", {
    filterKeywords: filterKeywords, pageToFetch: pageToFetch, groupType: groupType
    , filterUnread, filterPersonUnRead, filterNoActivity, filterSaleIds, filterCsIds, filterProvinceIds
    , companyType
  });
}

const generateGroupInviteCodeAsync = async (userGroupId: number) => {
  return await api.fnGet("chat-gen-invite-code", { userGroupId: userGroupId });
}


const generateGroupInviteCode2Async = async (userGroupId: number) => {
  return await api.fnGet("chat-gen-invite-code2", { userGroupId: userGroupId });
}


const getGroupInviteCodeAsync = async (userGroupId: number) => {
  return await api.fnGet("/chat-get-invite-code", { userGroupId: userGroupId });
}

const getGroupInviteCode2Async = async (userGroupId: number) => {
  return await api.fnGet("/chat-get-invite-code2", { userGroupId: userGroupId });
}


const getDirectMessages = () => {
  return api.get(url.GET_DIRECT_MESSAGES);
};
const getChannels = () => {
  return api.get(url.GET_CHANNELS);
};

const addContacts = (contacts: Array<string | number>) => {
  return api.create(url.ADD_CONTACTS, contacts);
};

const createChannel = (data: object) => {
  return api.create(url.CREATE_CHANNEL, data);
};

const getChatUserDetails = (id: string | number) => {
  return api.get(url.GET_CHAT_USER_DETAILS + "/" + id, { params: { id } });
};

const getChatUserDetails2s = (id: string | number) => {
  return api.fnGet(url.GET_CHAT_USER_DETAILS_2S, { id: id });
}

const getLastGroupChatInfoOfMember = (userOrGroupId: number) => {
  return api.fnPostForm(url.GET_LAST_GROUP_CHAT_INFO_OF_MEMBER, { userOrGroupId });
}

const delUserFromGroup = (groupId: number, memberId: number) => {
  return api.fnPostForm(url.DEL_USER_FROM_GROUP, { groupId: groupId, memberId: memberId });
}

const addUserToGroup = (groupId: number, memberId: number, isAdd: boolean) => {
  return api.fnPostForm(url.ADD_USER_TO_GROUP, { groupId: groupId, memberId: memberId, isAdd: isAdd });
}

const delGroupFromUser = (groupId: number, memberId: number) => {
  return api.fnPostForm(url.DEL_GROUP_FROM_USER, { groupId: groupId, memberId: memberId });
}

const applyUserToGroup = (memberId: number, inviteCode: string) => {
  return api.fnPostForm(url.APPLY_USER_TO_GROUP, { memberId: memberId, inviteCode: inviteCode });
}

const findMemberToGroup = (currentGroupId: any, filters: string, filterUserType: any) => {
  return api.fnPostForm(url.FIND_MEMBER_TO_GROUP, { currentGroupId: currentGroupId, filters: filters, filterUserType: filterUserType, });
}

const findDConnectWebUser = (groupChatId: any, filters: string) => {
  return api.fnPostForm(url.FIND_DCONNECT_WEB_USER, { groupChatId: groupChatId, filters: filters, });
}

const findDConnectCusForMatch = (customerCode: string, customerName: string) => {
  return api.fnPostForm(url.FIND_DCONNECT_CUS_FORMATCH, { customerCode, customerName });
}

const findErpSupForMatch = (supplierCode: string, supplierName: string) => {
  return api.fnPostForm(url.FIND_ERP_SUP_FORMATCH, { supplierCode, supplierName });
}

const ucChatAlighRight = (chatAlighRight: any) => {
  return api.fnPostForm("/uc-chat-aligh-right", { configValue: chatAlighRight });
}

// const getWebUserId = (activeGroupId: any) => {
//   return api.fnPostForm("/dconnect-get-web-userid", { activeGroupId: activeGroupId });
// }

const getWebUserId = (activeGroupId: any): Promise<sp_GetWebUserId> => {
  return api.fnPostForm("/dconnect-get-web-userid", { activeGroupId: activeGroupId });
}

const viewMsgMember = (msgId: string) => {
  return api.fnPostForm(url.VIEW_MSG_MEMBER, { msgId: msgId });
}

const viewMsgMemberAsync = async (msgId: string) => {
  return api.fnPostForm(url.VIEW_MSG_MEMBER, { msgId: msgId });
}

const applyUserToGroupAsync = async (memberId: number, inviteCode: string) => {
  return api.fnPostForm(url.APPLY_USER_TO_GROUP, { memberId: memberId, inviteCode: inviteCode });
}

const getChatUserConversationsPrev = (id: string | number, minDateTime?: string | null) => {
  // console.log('getChatUserConversationsPrev:' + minDateTime);
  return api.fnPostForm("/chat-get-conversion4", { iUserOrGroupId: id, sendDateTimeIso: minDateTime, direction: -1 });
}

const getChatUserConversationsNext = (id: string | number, maxDateTime?: string | null) => {
  // console.log('getChatUserConversationsNext:' + maxDateTime);
  return api.fnPostForm("/chat-get-conversion4", { iUserOrGroupId: id, sendDateTimeIso: maxDateTime, direction: 1 });
}

const getChatUserConversations = (id: string | number, sendDateTime?: string | null, direction?: number | null, isFromSearch?: boolean | null, markAllAsRead?: boolean | null) => {
  // console.log({ 'method': 'chat-get-conversion4', iUserOrGroupId: id, sendDateTime: sendDateTime, direction: direction});
  //return api.fnPostForm("/chat-get-conversion4", { iUserOrGroupId: id, sendDateTime: sendDateTime, direction: direction, isFromSearch });
  return api.fnPostForm("/chat-get-conversion4", { iUserOrGroupId: id, sendDateTimeIso: sendDateTime, direction: direction, isFromSearch, markAllAsRead });
  //const getChatUserConversations = (id: string | number, offset: number | null) => {
  // if (offset == null || offset === undefined) offset = -1;
  // console.log('getChatUserConversationsApi:', {id, offset});
  // return api.fnPostForm("/chat-get-conversion3", { iUserOrGroupId: id, offset: offset });

  /*
  // console.log('getChatUserConversations ' + id);
  if (Utils.IsNumeric(id)) {
    // console.log('getChatUserConversations from 2s = ' + id);
    return api.fnGet("/chat-get-conversion", { iUserOrGroupId: id });
    // return api.fnGet("/chat-get-user-details", { iUserOrGroupId: id });
  } else {
    // console.log('getChatUserConversations from fake ' + id);
    return api.get(url.GET_CHAT_USER_CONVERSATIONS + "/" + id, {
      params: { id },
    });
  }
    */
};

const loadCustomerContent = (groupId: number) => {
  return api.fnPostForm("/chat-get-cus-content", { groupId: groupId });
}

const getContentUnreadCount = (userOrGroupId: number, titleId: number) => {
  console.log('API const getContentUnreadCount:', { userOrGroupId, titleId })
  return api.fnPostForm("/get-content-unread-count", { userOrGroupId: userOrGroupId, titleId: titleId });
}

const getAllContentUnreadCount = (userOrGroupId: number) => {
  // console.log('API const getAllContentCount:', { userOrGroupId })
  return api.fnPostForm("/get-content-unread-count-all", { userOrGroupId: userOrGroupId });
}

const getContentList = (userOrGroupId: number, contentTitleId: number | null) => {
  return api.fnPostForm("/get-content-list", { userOrGroupId, contentTitleId });
}

const erpGetCustomerTask = (userOrGroupId: number) => {
  //console.log('erpGetCustomerTask API:', userOrGroupId);
  //return api.fnPost(url.ERP_GET_CUSTOMER_TASK, { userOrGroupId: 179 });
  return api.fnPostForm(url.ERP_GET_CUSTOMER_TASK, { userOrGroupId });
}

const erpGetPrevTopNoVolume = (userOrGroupId: number) => {
  return api.fnPostForm(url.ERP_GET_PREV_TOP_NO_VOLUME, { userOrGroupId });
}

const erpCateSizeNotSaleMoreThan45 = (userOrGroupId: number) => {
  return api.fnPostForm(url.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45, { userOrGroupId });
}

const erpCateInterestNotSale = (userOrGroupId: number) => {
  return api.fnPostForm(url.ERP_CATE_INTEREST_NOT_SALE, { userOrGroupId });
}

const erpCateNotSaleMoreThan60 = (userOrGroupId: number) => {
  return api.fnPostForm(url.ERP_CATE_NOT_SALE_MORE_THAN_60, { userOrGroupId });
}

const rotateImageFileAsync = async (fileId: string, degree: number) => {
  return api.fnPostForm(url.ROTATE_IMAGE_FILE, { fileId, degree });
}

export const fetchCustomer = (offset: number, limit: number) => {
  return api.fnPostForm("/test-fetch", { offset: offset, limit: limit });
}

const sendMessage = (data: object) => {
  return api.create(url.SEND_MESSAGE, data);
};

const receiveMessage = (id: string | number) => {
  return api.update(url.RECEIVE_MESSAGE + "/" + id, { params: { id } });
};

const readMessage = (id: string | number) => {
  return api.update(url.READ_MESSAGE + "/" + id, { params: { id } });
};

const receiveMessageFromUser = (id: string | number) => {
  return api.get(url.RECEIVE_MESSAGE_FROM_USER + "/" + id, {
    params: { id },
  });
};

const deleteMessage = (userId: number | string, messageId: number | string) => {
  return api.delete(url.DELETE_MESSAGE + "/" + userId + "/" + messageId, {
    params: { userId, messageId },
  });
};

const forwardMessage = (data: object) => {
  return api.create(url.FORWARD_MESSAGE, data);
};

const deleteUserMessages = (userId: number | string) => {
  return api.delete(url.DELETE_USER_MESSAGES + "/" + userId, {
    params: { userId },
  });
};

const getChannelDetails = (id: string | number) => {
  return api.get(url.GET_CHANNEL_DETAILS + "/" + id, { params: { id } });
};

const toggleFavouriteContact = (id: string | number) => {
  return api.update(url.TOGGLE_FAVOURITE_CONTACT + "/" + id, {
    params: { id },
  });
};

/*
archive
*/
const getArchiveContact = () => {
  return api.get(url.GET_ARCHIVE_CONTACT);
};

const toggleArchiveContact = (id: string | number) => {
  return api.update(url.TOGGLE_ARCHIVE_CONTACT + "/" + id, { params: { id } });
};

const readConversation = (id: string | number) => {
  return api.update(url.READ_CONVERSATION + "/" + id, { params: { id } });

};

const deleteImage = (
  userId: number | string,
  messageId: number | string,
  imageId: number | string
) => {
  return api.delete(url.DELETE_IMAGE + "/" + userId + "/" + messageId, {
    params: { userId, messageId, imageId },
  });
};

const updateReadMsg = (userGroupId: number, msgIds: any) => api.fnPostForm("/update-read-msg", { userGroupId, msgIds });
const setRespEmoji = (msgId: any, emojiName: any, emojiSymbol: any) => {
  // console.log({ msgId, emojiName, emojiSymbol });
  api.fnPostForm("/set-resp-emoji", { msgId, emojiName, emojiSymbol })
};
const unsendMessage = (msgId: any) => {
  // console.log({ msgId, emojiName, emojiSymbol });
  return api.fnPostForm("/unsend-message", { msgId })
};
const getUserReadMsg = (msgId: string | number) => api.fnGet("",);

const findForFilterChatRoom = (notYetRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, keywordMode: string | null, topRow: number, keyword: string | null) => {
  return api.fnPostForm(url.FIND_FOR_FILTER_CHAT_ROOM, { notYetRead, personUnRead, noActivity, keywordMode, topRow, keyword });
}

export const searchChat = (userOrGroupId: number, page: number, keyword: string) => {
  return api.fnPostForm(url.SEARCH_CHAT, { userOrGroupId, page, keyword });
}

export const quickReplyLoadAllApi = () => {
  return api.fnPostForm(url.QUICK_REPLY_LOAD_ALL, {});
}

export {
  getFavourites,
  getDirectMessages,
  getChannels,
  addContacts,
  createChannel,
  getChatUserDetails,
  getChatUserConversations, getChatUserConversationsPrev, getChatUserConversationsNext,
  sendMessage,
  receiveMessage,
  readMessage,
  receiveMessageFromUser,
  deleteMessage,
  forwardMessage,
  deleteUserMessages,
  getChannelDetails,
  toggleFavouriteContact,
  getArchiveContact,
  toggleArchiveContact,
  readConversation,
  deleteImage,

  /*getChatRoomLists,*/ getChatRoomListsV2, getChatUserDetails2s, generateGroupInviteCodeAsync, generateGroupInviteCode2Async, getGroupInviteCodeAsync, getGroupInviteCode2Async,
  updateReadMsg, delUserFromGroup, addUserToGroup, delGroupFromUser, applyUserToGroup, applyUserToGroupAsync,
  findMemberToGroup, viewMsgMember, viewMsgMemberAsync,

  /* customer content */
  loadCustomerContent, getContentUnreadCount, getAllContentUnreadCount, getContentList,
  getWebUserId,
  findDConnectWebUser, findDConnectCusForMatch, findErpSupForMatch, 
  setRespEmoji, getLastGroupChatInfoOfMember,
  ucChatAlighRight, unsendMessage, findForFilterChatRoom,
  erpGetCustomerTask, erpGetPrevTopNoVolume, erpCateSizeNotSaleMoreThan45, erpCateInterestNotSale, erpCateNotSaleMoreThan60,
  rotateImageFileAsync

};
